import React, { useEffect, useState } from "react";
import { updateCoachingFeedbackByAdmin } from "../../../../../services/admin";
import { toast } from "react-toastify";

export default function PublishFeedbackCoaching({ editFeedbackDetail, callBack }) {
    const [aboutVerysoul, setaboutVerysoul] = useState("");
    const [answer_21, setanswer_21] = useState("");
    const [answer_23, setanswer_23] = useState("");
    const [
        answer_1,
        setAnswer_1,
    ] = useState("");
    const [answer_22, setanswer_22] = useState("");

    ///
    const [aboutVerysoulPublish, setaboutVerysoulPublish] = useState("");
    const [answer_21Publish, setanswer_21Publish] = useState("");
    const [answer_23Publish, setanswer_23Publish] = useState("");
    const [
        answer_1Publish,
        setAnswer_1Publish,
    ] = useState("");
    const [answer_22Publish, setanswer_22Publish] = useState("");

    const [answer_3Publish, setanswer_3Publish] = useState("");
    const [answer_3, setanswer_3] = useState("");

    const [answer_4, setanswer_4] = useState("");
    const [answer_4Publish, setanswer_4Publish] = useState("");
    const [tookturn, settookturn] = useState("");
    const [tookturnPublish, settookturnPublish] = useState("");

    const [feedbackId, setFeedbackId] = useState('')

    //effects
    const clearStates = () => {
        setaboutVerysoul("");
        setanswer_21("");
        setanswer_23("");
        setAnswer_1("");
        setanswer_22("");
        setanswer_3("");
        setanswer_4("");
        settookturn("");

        /// publisheabele
        setaboutVerysoulPublish("");
        setanswer_21Publish("");
        setanswer_23Publish("");
        setAnswer_1Publish("");
        setanswer_22Publish("");
        setanswer_3Publish("")
        setanswer_4Publish("");
        settookturnPublish("");

        setFeedbackId("")

    }
    useEffect(() => {
        console.log("editFeedbackDetailAnuj", editFeedbackDetail)
        if (editFeedbackDetail !== undefined) {
            let feedback;
            let id;
            let publish;
            if ((Object.keys(editFeedbackDetail).length) === 1) {

                if (Object.values(editFeedbackDetail)[0].edited_feedback === null) {
                    publish = Object.values(editFeedbackDetail)[0].feedback;
                }
                else {
                    publish = Object.values(editFeedbackDetail)[0].edited_feedback;
                }
                feedback = Object.values(editFeedbackDetail)[0].feedback;


                id = Object.values(editFeedbackDetail)[0].feedback_id
            }
            else {

                if (Object.values(editFeedbackDetail)[1].edited_feedback === null) {
                    publish = Object.values(editFeedbackDetail)[1].feedback;
                }
                else {
                    publish = Object.values(editFeedbackDetail)[1].edited_feedback;
                }


                feedback = Object.values(editFeedbackDetail)[1].feedback;
                id = Object.values(editFeedbackDetail)[1].feedback_id
            }
            setaboutVerysoul(feedback.about_verysoul);
            setanswer_21(feedback.answer_21);
            setanswer_23(feedback.answer_23);
            setAnswer_1(
                feedback.answer_1
            );
            setanswer_22(feedback.answer_22);
            setanswer_3(feedback.answer_3);

            settookturn(feedback.took_turn);
            setanswer_4(feedback.answer_4);

            /// publisheabele
            setaboutVerysoulPublish(publish.about_verysoul);
            setanswer_21Publish(publish.answer_21);
            setanswer_23Publish(publish.answer_23);
            setAnswer_1Publish(
                publish.answer_1
            );
            setanswer_3Publish(publish.answer_3);
            setanswer_22Publish(publish.answer_22);
            settookturnPublish(publish.took_turn);
            setanswer_4Publish(publish.answer_4);

            setFeedbackId(id)
        }
    }, [editFeedbackDetail]);

    const onChangeHandler = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        // let check = (value > 0 && value < 6 || value === "")
        let check = true
        if (name === "aboutVerysoulPublish") {

            setaboutVerysoulPublish(value);

        }
        if (name === "answer_21Publish" && check) {
            setanswer_21Publish(value);
        }
        if (name === "answer_23Publish") {
            setanswer_23Publish(value);
        }
        if (name === "answer_1Publish" && check) {
            setAnswer_1Publish(value);
        }
        if (name === "answer_22Publish" && check) {
            setanswer_22Publish(value);
        }
        if (name === "answer_3Publish" && check) {
            setanswer_3Publish(value);
        }
        if (name === "answer_4Publish" && check) {
            setanswer_4Publish(value);
        }
       
    };

    const onCancelHandler = () => {
        // window.loadModal2("#editFeedback", "hide");
        clearStates()
        window.loadModal2("#publishFeedback", "hide");
    };

    const updateHandler = () => {
        let body = {
            feedback_id: feedbackId,
            answer_1: answer_1Publish,
            answer_21: answer_21Publish,
            answer_22: answer_22Publish,
            answer_23: answer_23Publish,
            answer_3: answer_3Publish,
            answer_4: answer_4Publish,
           
        }

        updateCoachingFeedbackByAdmin(body)
            .then((data) => {
                if (data.data.status) {
                    toast.success('Feedback updated succesfully', { position: 'top-center' })
                    callBack()
                    // window.loadModal2('#editFeedback', 'hide');
                    clearStates()
                    window.loadModal2("#publishFeedback", "hide");
                }
            })
            .catch(() => {
                toast.error('Error', { position: 'top-center' })
            });
    };
    return (
        <div
            className="modal fade "
            id="publishFeedback"
            // data-backdrop="static"
            role="dialog"
        >
            <div className="modal-dialog modal-lg  modal-dialog-preview">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="editable-form-feedback">
                            <div className="schedule-popup">
                                {/* <img src="../images/new-cll.png" alt="user" /> */}

                                <h3 className="mb-4 text-center mt-2">Client Feedback</h3>
                                <div>
                                    <div className="from-fild mt-2 mb-4">
                                        <label htmlFor="firstName">
                                        Want Others to Know 
                                        </label>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <input
                                                // onChange={onChangeHandler}
                                                value={answer_1}
                                                type="text"
                                                id="answer_1"
                                                name="answer_1"
                                                placeholder="Want Others to Know"
                                                min={1}
                                                max={5}
                                            />
                                        </div>
                                    </div>
                                    <div className="from-fild mt-2 mb-4">
                                        <label htmlFor="firstName">Word to Describe Coach (1)</label>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <input
                                                // onChange={onChangeHandler}
                                                value={answer_21}
                                                type="text"
                                                id="answer_21"
                                                name="answer_21"
                                                placeholder="Word to Describe Coach (1)"
                                            />
                                        </div>
                                    </div>


                                    <div className="from-fild mt-2 mb-4">
                                        <label htmlFor="firstName">Word to Describe Coach (2) </label>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <input
                                                // onChange={onChangeHandler}
                                                value={answer_22}

                                                type="text"
                                                id="answer_22"
                                                name="answer_22"
                                                placeholder="Word to Describe Coach (2) "
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="from-fild mt-2 mb-4">
                                    <label htmlFor="firstName">Word to Describe Coach (3)</label>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <input
                                            // onChange={onChangeHandler}
                                            value={answer_23}
                                            type="text"
                                            id="answer_23"
                                            name="answer_23"
                                            placeholder="Word to Describe Coach (3)"
                                        />
                                    </div>
                                </div>
                                <div className="from-fild mt-2 mb-4">
                                    <label htmlFor="firstName">How this Session Helped </label>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <input
                                            // onChange={onChangeHandler}
                                            value={answer_3}
                                            type="text"
                                            id="answer_3"
                                            name="answer_3"
                                            placeholder="How this Session Helped "
                                        />
                                    </div>
                                </div>
                                <div className="from-fild mt-2 mb-4">
                                    <label htmlFor="firstName">Private Message</label>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <input
                                            // onChange={onChangeHandler}
                                            value={answer_4}
                                            type="text"
                                            id="answer_4"
                                            name="answer_4"
                                            placeholder="Private Message"
                                        />
                                    </div>
                                </div>
                                
                                {/* <div className="from-fild mt-2 mb-4">
                                    <label htmlFor="firstName">About Verysoul</label>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <textarea
                                            className="feedback-text-area"
                                            rows={6}
                                            // onChange={onChangeHandler}
                                            value={aboutVerysoul}
                                            type="text"
                                            id="aboutVerysoul"
                                            name="aboutVerysoul"
                                            placeholder="About Verysoul"
                                        />
                                    </div>
                                </div> */}
                                {/* <div className="d-flex justify-content-between">
                                    <div
                                        className="advance-tag pointer text-center width-150px"
                                        onClick={onCancelHandler}
                                    >
                                        Cancel
                                    </div>
                                    <div
                                        className="advance-tag pointer text-center width-150px ml-2"
                                        onClick={updateHandler}
                                    >
                                        Update
                                    </div>
                                </div> */}
                            </div>
                            <div className="schedule-popup">
                                {/* <img src="../images/new-cll.png" alt="user" /> */}

                                <h3 className="mb-4 text-center mt-2">Publishable Feedback</h3>
                                <div>
                                    <div className="from-fild mt-2 mb-4">
                                        <label htmlFor="firstName">
                                        Want Others to Know 
                                        </label>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <input
                                                onChange={onChangeHandler}
                                                value={answer_1Publish}
                                                type="text"
                                                id="answer_1Publish"
                                                name="answer_1Publish"
                                                placeholder="Want Others to Know"

                                            />
                                        </div>
                                    </div>
                                    <div className="from-fild mt-2 mb-4">
                                        <label htmlFor="firstName">Word to Describe Coach (1)</label>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <input
                                                onChange={onChangeHandler}
                                                value={answer_21Publish}

                                                type="text"
                                                id="answer_21Publish"
                                                name="answer_21Publish"
                                                placeholder="Word to Describe Coach (1)"
                                            />
                                        </div>
                                    </div>


                                    <div className="from-fild mt-2 mb-4">
                                        <label htmlFor="firstName">Word to Describe Coach (2) </label>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <input
                                                onChange={onChangeHandler}
                                                value={answer_22Publish}

                                                type="text"
                                                id="answer_22Publish"
                                                name="answer_22Publish"
                                                placeholder="Word to Describe Coach (2) "
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="from-fild mt-2 mb-4">
                                    <label htmlFor="firstName">Word to Describe Coach (3)</label>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <input
                                            onChange={onChangeHandler}
                                            value={answer_23Publish}
                                            type="text"
                                            id="answer_23Publish"
                                            name="answer_23Publish"
                                            placeholder="Word to Describe Coach (3)"
                                        />
                                    </div>
                                </div>
                                <div className="from-fild mt-2 mb-4">
                                    <label htmlFor="firstName">How this Session Helped </label>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <input
                                            onChange={onChangeHandler}
                                            value={answer_3Publish}
                                            type="text"
                                            id="answer_3Publish"
                                            name="answer_3Publish"
                                            placeholder="How this Session Helped "
                                        />
                                    </div>
                                </div>
                                <div className="from-fild mt-2 mb-4">
                                    <label htmlFor="firstName">Private Message</label>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <input
                                            onChange={onChangeHandler}
                                            value={answer_4Publish}
                                            type="text"
                                            id="answer_4Publish"
                                            name="answer_4Publish"
                                            placeholder="Private Message"
                                        />
                                    </div>
                                </div>
                                
                                {/* <div className="from-fild mt-2 mb-4">
                                    <label htmlFor="firstName">About Verysoul</label>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <textarea
                                            rows={6}
                                            className="feedback-text-area"
                                            onChange={onChangeHandler}
                                            value={aboutVerysoulPublish}
                                            type="text"
                                            id="aboutVerysoulPublish"
                                            name="aboutVerysoulPublish"
                                            placeholder="About Verysoul"
                                        />
                                    </div>
                                </div> */}
                                <div className="d-flex justify-content-between">
                                    <div
                                        className="advance-tag-new pointer text-center width-150px  model-close-btn"
                                        onClick={onCancelHandler}
                                    >
                                        Cancel
                                    </div>
                                    <div
                                        className="advance-tag pointer text-center width-150px ml-2"
                                        onClick={updateHandler}
                                    >
                                        Update
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
